namespace Areas.Report {
    "use strict";

    export function gotoProjectInitiationReportFromForm() {
        var form = $('#ProjectInfoUpdateForm').dxForm('instance');
        let keyId: any = form.option('ProjectInfoId');
        if (keyId != null) {
            const url = `/Custom/Report/ProjectInitiationReport/${keyId}`;
            window.open(url);
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    } 

}



